<template>
  <div class="cxdj-container">
    <!-- 顶部供应求购切换 -->
    <el-tabs v-model="activeMainTab" @tab-click="handleMainTabChange">
      <el-tab-pane label="产品供应" name="supply"></el-tab-pane>
      <el-tab-pane label="产品求购" name="demand"></el-tab-pane>
    </el-tabs>

    <!-- 产品分类切换 -->
    <el-tabs v-model="activeCategory" type="card" @tab-click="handleCategoryChange">
      <el-tab-pane label="全部" name="all"></el-tab-pane>
      <el-tab-pane
        v-for="item in categoryList"
        :key="item.id"
        :label="item.name"
      ></el-tab-pane>
    </el-tabs>

    <!-- 搜索框 -->
    <el-input
      v-model="searchKey"
      placeholder="搜索产品名称或地点..."
      class="search-box"
      @keyup.enter.native="handleSearch"
    />

    <!-- 产品列表 -->
    <div class="product-list">
      <el-row :gutter="24">
        <el-col
          v-for="item in productList"
          :key="item.id"
          :xs="24" :sm="12" :md="8" :lg="8"
        >
          <el-card class="product-card"
            @click.native="handleCardClick(item.id)"
            :style="{ cursor: 'pointer', '&:hover': { boxShadow: '0 2px 12px 0 rgba(0,0,0,.1)' } }"
          >
            <div class="card-content">
              <img :src="item.productImage" class="product-image" />
              <div class="product-info">
                <div class="header-line">
                  <h4>{{ item.cropName }}</h4>
                  <el-tag
                    :class="[item.type == 2 ? 'supply-tag' : 'demand-tag']"
                    effect="dark"
                    size="small"
                  >
                    {{ item.type == 2 ? '供应' : '求购' }}
                  </el-tag>
                  <span class="num">{{ item.num }}{{ item.unit }}</span>
                  <span class="time">{{ item.createTime }}</span>
                </div>
                <div class="bottom-info">
                  <div class="info-item">
                    <span class="label">价格：</span>
                    <span class="price">{{ item.price }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">地址：</span>
                    <span class="value">{{ item.address }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">补充说明：</span>
                    <span class="value">{{ item.memo }}</span>
                  </div>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- 加载更多 -->
    <div class="load-more">
      <el-button
        :loading="loading"
        @click="loadMore"
        v-if="hasMore"
      >
        加载更多
      </el-button>
    </div>
  </div>
</template>

<script>
import { getSupplyOrderList, getProductCategoryTree } from '@/api/supplyOrder';
import Card from "@/components/Card/index.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    Card
  },
  computed: mapGetters(["identityObj","topSelectAreacode"]),
  data() {
    return {
      baseUrl: window.globalUrl.HOME_API,
      activeMainTab: 'supply', // 供应/求购切换
      activeCategory: 'all',   // 当前选中分类
      searchKey: '',           // 搜索关键词
      categoryList: [],        // 分类数据
      productList: [],         // 产品列表
      currentPage: 1,
      pageSize: 12,
      total: 0,
      loading: false,
      hasMore: false
    }
  },
   watch: {
    topSelectAreacode() {
      this.loadProducts();
    },
  },
  mounted() {
    this.loadCategories()
    this.loadProducts()
  },
  methods: {
    // 加载产品分类
    async loadCategories() {
      const { data } = await getProductCategoryTree()
      this.categoryList = data.filter(item => item.parentId === -1) // 只取一级分类
    },

    formatTime(timeStr) {
      if (!timeStr) return '';
      const now = Date.now();
      const time = new Date(timeStr).getTime();
      const diff = now - time;

      // 时间差计算
      const minute = 60 * 1000;
      const hour = minute * 60;
      const day = hour * 24;
      const month = day * 30;

      if (diff < minute) {
        return '刚刚';
      } else if (diff < hour) {
        return `${Math.floor(diff / minute)}分钟前`;
      } else if (diff < day) {
        return `${Math.floor(diff / hour)}小时前`;
      } else if (diff < month) {
        return `${Math.floor(diff / day)}天前`;
      }

      // 超过30天显示完整日期
      const date = new Date(timeStr);
      return `${date.getFullYear()}-${(date.getMonth()+1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    },

    // 加载产品列表
    async loadProducts() {
      this.loading = true
      try {
        const params = {
          type: this.activeMainTab === 'supply' ? 2 : 1,
          productCategoryId: this.activeCategory === 'all' ? '' : this.activeCategory,
          keyword: this.searchKey,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          allFlag: '0',
          areaCode: this.topSelectAreacode
        }

        const { data } = await getSupplyOrderList(params)

        //处理获取的数据
        if (data.records != null && data.records.length > 0) {
          data.records.forEach(item => {
            item.createTime = this.formatTime(item.createTime)
            // 处理图片数据
            item.productImage = item.img
              ? (() => {
                  try {
                    const imgs = JSON.parse(item.img);
                    return Array.isArray(imgs)
                      ? this.baseUrl + 'admin/file/get?ossFilePath=' + imgs[0].url
                      : this.baseUrl + 'admin/file/get?ossFilePath=' + item.icon;
                  } catch {
                    return this.baseUrl + 'admin/file/get?ossFilePath=' + item.icon;
                  }
                })()
              : this.baseUrl + 'admin/file/get?ossFilePath=' + item.icon;
          })
        }
        this.productList = [...this.productList, ...data.records]

        this.hasMore = data.current < data.pages
        this.total = data.total
      } finally {
        this.loading = false
      }
    },

    // 切换主Tab
    handleMainTabChange() {
      this.resetList()
    },

    // 切换分类
    handleCategoryChange() {
      this.resetList()
    },

    // 搜索处理
    handleSearch() {
      this.resetList()
    },

    // 加载更多
    loadMore() {
      this.currentPage++
      this.loadProducts()
    },

    // 重置列表
    resetList() {
      this.currentPage = 1
      this.productList = []
      this.loadProducts()
    },

    handleCardClick(id) {
      console.log('handleCardClick进来了')
      this.$router.push({
        path: '/quickLink/supplyOrderDetail',
        query: { id: id }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.cxdj-container {
  padding: 20px;
  .el-tabs {
    margin-bottom: 20px;
  }
  .search-box {
    width: 800px;
    margin: 20px 0;
  }
  .product-card {
    transition: all 0.3s;
    margin-bottom: 20px;
    :deep(.el-card__body) {
      padding: 20px;
      height: 180px;
      display: flex;
      flex-direction: column;
    }
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }


  .card-content {
    display: flex;
    gap: 20px;
    padding: 15px;

    .product-image {
      width: 60px;
      height: 60px;
      object-fit: cover;
      border-radius: 4px;
    }

    .product-info {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      h4 {
        margin: 0 0 8px 0;
        font-size: 16px;
        line-height: 1.4;
      }

      p {
        margin: 4px 0;
        font-size: 13px;

        &.price {
          color: #f56c6c;
          font-weight: 600;
          font-size: 15px;
        }

        &.stock {
          color: #67c23a;
        }
      }
    }
  }
}
  .load-more {
    text-align: center;
    margin-top: 20px;
  }
}

.header-line {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;

  h4 {
    margin: 0;
    font-size: 16px;
  }

  .el-tag {
    border: none;
    &.supply-tag {
      background: #67c23a;
      color: white;
    }
    &.demand-tag {
      background: #e6a23c;
      color: white;
    }
  }

  .num {
    font-size: 14px;
    color: #606266;
  }
}

.bottom-line {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .price {
    color: #f56c6c;
    font-weight: 500;
    margin: 0;
  }

}

.time {
  font-size: 12px;
  color: #909399;
  margin-left: 10px;
}

.bottom-info {
  width: 100%;
  margin-top: 12px;
  .info-item {
    display: flex;
    align-items: baseline;
    margin-bottom: 8px;
    font-size: 13px;
    .price {
      color: #c89020;
      font-weight: 500;
    }
    .label {
      color: #666;
      min-width: 45px;
    }
    .value {
      color: #333;
      flex: 1;
      word-break: break-all;
    }
  }
}
</style>
